import React, { useEffect, useState } from "react";
import { Image, Row, Container, Col } from "react-bootstrap";
import queryString from "query-string";
import Services from "../../services/Services";


const globalCloseModal = () => {
  if (window && window.parent) {
    var parent = window.parent;
    analyticsChanges();
    parent.postMessage("Close", "*");
  }
};

export function GlobalErrorPage(props) {
  const {
    d2dFlow = props.d2dFlow,
    errorMsg = "",
    errorDescription,
    errorHeader,
    errorImageUrl,
    bannerImage,
    mppPrimaryColors,
    footerLogo,
    onlineUsageAgreement,
    onlinePrivacyPolicy,
    accessibility,
  } = queryString.parse(props.location?.search);

  const hasHeaderBranding = !!bannerImage;
  const hasFooterBranding = !!footerLogo;
  const showHeaderFooter = hasHeaderBranding && hasFooterBranding;

  return (
    <div className="mpp-wrapper">
      {showHeaderFooter && (
        <div className="modal-header" role="header" style={{ borderColor: mppPrimaryColors }}>
          <div className="modal-title h4">
            <div className="float-left zetailImgDiv">
              <img src={bannerImage} className="zetailimg" alt="" />
            </div>
          </div>
        </div>
      )}
      <div className="modal-body">

        <div className={errorDescription || errorMsg ? "global-error-layout__body" : "errorContent"}>
          <div className="global-error-layout__icon-heading">
            {errorImageUrl && (
              <div className="global-error-layout__placeholder">
                <img src={errorImageUrl} alt="D2D Flow Image" />
              </div>
            )}
            {errorHeader && <p className="global-error-layout__title">{errorHeader}</p>}
          </div>
          <p className="global-error-layout__message">
            {errorDescription || errorMsg ||
              "There was a problem with your most recent request, please close this window and try again. If the problem persists, please contact your retailer."}
          </p>
          {d2dFlow !== "Y" && (
            <div className="row form-group buttons-bottm buttons-single">
              <div className="col-xs-12">
                <input
                  type="button"
                  className="btn btn-primary btn-lg btn-block bg-color1 syfClickEvent global-error-close-btn"
                  value="Close"
                  onClick={globalCloseModal}
                  title="Close"
                  data-type="Generic"
                  data-object="button"
                  data-reason="Close"
                  tabIndex="0"
                />
              </div>
            </div>
          )}
        </div>

      </div>

      {showHeaderFooter && (
        <div className="modal-footer">
          <Container fluid={true} style={{ margin: "0px" }}>
            <div className="syncImg">
              <div className="pl-0 imageContainer">
                <Image variant="top" src={footerLogo} alt="Synchrony Logo" />
              </div>
              <div className="pl-0 pr-0 text-end refeContainer">
                <p className="footerText">
                  {onlineUsageAgreement && (
                    <>
                      <a
                        href={onlineUsageAgreement}
                        className="color3 syfClickEvent"
                        target="_blank"
                        data-type="Generic"
                        data-object="link"
                        title="opens in a new window"
                        style={{ color: mppPrimaryColors }}
                        data-reason="Web Site Usage Agreement"
                        id="agreement"
                        aria-labelledby="opens in a new window"
                        tabIndex="0" rel="noreferrer"
                      >
                        Usage Agreement
                      </a>
                      <span className="removebar" aria-hidden="true"> | </span>
                    </>
                  )}
                  {onlinePrivacyPolicy && (
                    <>
                      <a
                        href={onlinePrivacyPolicy}
                        style={{ color: mppPrimaryColors }}
                        className="color3 syfClickEvent"
                        id="onlinePrivacyPolicy"
                        target="_blank"
                        data-type="Generic"
                        data-object="link"
                        title="opens in a new window"
                        data-reason="Privacy Policy"
                        aria-labelledby="opens in a new window"
                        tabIndex="0" rel="noreferrer"
                      >
                        Online Privacy Policy
                      </a>
                      <span className="removebar" aria-hidden="true"> | </span>
                    </>
                  )}
                  {accessibility && (
                    <>
                      <a
                        href={accessibility}
                        style={{ color: mppPrimaryColors }}
                        className="color3 syfClickEvent"
                        id="accessibility"
                        target="_blank"
                        data-type="Generic"
                        data-object="link"
                        data-reason="Accessibility"
                        title="opens in a new window"
                        aria-labelledby="opens in a new window"
                        tabIndex="0" rel="noreferrer"
                      >
                        Accessibility
                      </a>
                      <span className="removebar" aria-hidden="true"> | </span>
                    </>
                  )}
                  {onlinePrivacyPolicy && (
                    <a
                      href={onlinePrivacyPolicy + "#ca-dnss"}
                      style={{ color: mppPrimaryColors }}
                      className="color3 syfClickEvent"
                      id="ca_residents"
                      target="_blank"
                      data-type="Generic"
                      data-object="link"
                      data-reason="CA Residents - Do Not Sell/Share"
                      title="opens in a new window"
                      aria-labelledby="opens in a new window"
                      tabIndex="0" rel="noreferrer"
                    >
                      CA Residents - Do Not Sell/Share
                    </a>
                  )}
                </p>
              </div>
            </div>
          </Container>
        </div>
      )}
    </div>
  );
}

export function MerchantPriceErrorPage() {
  return (
    <div className="errorContent">
      <p className="price-error-msg">
        Your order total does not meet the requirements to use this payment
        method
      </p>
    </div>
  );
}

export function TransactionPage(props) {
  const [brandingInfo, setBrandingInfo] = useState({});

  useEffect(() => {
    window.addEventListener("orientationchange", () => {
      const afterOrientationChange = () => {
        document.documentElement.style.setProperty(
          "--screen-height",
          window.innerHeight + "px"
        );
        window.removeEventListener("resize", afterOrientationChange);
      };

      window.addEventListener("resize", afterOrientationChange);
    });
    const { partnerId, partnerProfileCode } = queryString.parse(props.location.search);
    getBrandingInfo(partnerId, partnerProfileCode);
    setWindowHeight();
  }, []);

  const setWindowHeight = () => {
    document.documentElement.style.setProperty(
      "--screen-height",
      window.innerHeight + "px"
    );
    document.documentElement.style.setProperty(
      "--mpp-model-body-height",
      "135px"
    );
  };

  const {
    bannerImage,
    bannerAltText,
    mppPrimaryColors,
    footerLogo,
    onlineUsageAgreement,
    onlinePrivacyPolicy,
    accessibility,
    merchantName
  } = brandingInfo;

  const isCareCredit = merchantName?.toLowerCase() === "carecredit";

  const closeBtnFocus = (event) => {
    if (event.shiftKey && event.keyCode === 9) {
      window.parent.postMessage("agreement", "*");
    } else if (event.keyCode === 9) {
      window.parent.postMessage("closeBtnFocus", "*");
    }
  };

  const getBrandingInfo = (partnerId, partnerProfileCode) => {
    const requestFields = {
      "lookupField": ["product_details", "merchant_details"]
    }

    Services.fetchBrandInfo(
      partnerId, partnerProfileCode, requestFields
    ).then((response) => {
      const { product_details, merchant_details } = response;
      const {
        bannerImage,
        bannerAltText,
        mppPrimaryColors,
        onlineUsageAgreement,
        onlinePrivacyPolicy,
        footerLogo,
        accessibility
      } = product_details.mpp.product_specific_branding;
      const { merchantName } = merchant_details
      setBrandingInfo({
        bannerImage,
        bannerAltText,
        mppPrimaryColors,
        onlineUsageAgreement,
        onlinePrivacyPolicy,
        footerLogo,
        accessibility,
        merchantName
      });
    });

  }

  return (
    <>
      <div
        className="modal-header" role="header"
        style={{ borderColor: mppPrimaryColors }}
      >
        <div className="modal-title h4 ifDesktopHeader ">
          <div className="float-left zetailImgDiv">
            <img
              src={bannerImage}
              className="zetailimg"
              alt={merchantName}
              title={merchantName}
            />
          </div>
        </div>
      </div>
      <div className="modal-body globalError-page" role="status" aria-live="polite">
        <div className="success-heading">Congratulations</div>
        <p className="success-info">
          Review your purchase with an associate to complete your transaction.
        </p>
      </div>
      <div className="modal-footer">
        <Container fluid={true} style={{ margin: "0px" }}>
          <div className="syncImg">
            <div className="pl-0 imageContainer">
              <Image
                variant="top"
                src={footerLogo}
                alt="Synchrony Logo"
                style={
                  isCareCredit ? { width: "117px", height: "16px" } : {}
                }
              />
            </div>
            <div className="pl-0 pr-0  text-end refeContainer">
              <p className="footerText">
                <a
                  href={onlineUsageAgreement}
                  className="color3 syfClickEvent"
                  target="_blank"
                  data-type="Generic"
                  data-object="link"
                  title="opens in a new window"
                  style={{ color: mppPrimaryColors }}
                  data-reason="Web Site Usage Agreement"
                  id="agreement"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Usage Agreement
                </a>
                <span className="removebar" aria-hidden="true"> | </span>
                <a
                  href={onlinePrivacyPolicy}
                  style={{ color: mppPrimaryColors }}
                  className="color3 syfClickEvent"
                  id="onlinePrivacyPolicy"
                  target="_blank"
                  data-type="Generic"
                  data-object="link"
                  title="opens in a new window"
                  data-reason="Privacy Policy"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Online Privacy Policy
                </a>
                <span className="removebar" aria-hidden="true"> | </span>
                <a
                  href={accessibility}
                  style={{ color: mppPrimaryColors }}
                  className="color3 syfClickEvent"
                  id="accessibility"
                  target="_blank"
                  onKeyDown={closeBtnFocus}
                  data-type="Generic"
                  data-object="link"
                  data-reason="Accessibility"
                  title="opens in a new window"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  Accessibility
                </a>
                <span className="removebar" aria-hidden="true"> | </span>
                <a
                  href={onlinePrivacyPolicy + "#ca-dnss"}
                  style={{ color: mppPrimaryColors }}
                  className="color3 syfClickEvent"
                  id="ca_residents"
                  target="_blank"
                  onKeyDown={closeBtnFocus}
                  data-type="Generic"
                  data-object="link"
                  data-reason="CA Residents"
                  title="opens in a new window"
                  aria-labelledby="opens in a new window"
                  tabIndex="0" rel="noreferrer"
                >
                  CA Residents - Do Not Sell/Share
                </a>
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

function analyticsChanges() {
  window._syf_._mppOffer_._SFDDL.pageInfo = {
    Country_Language: "US|ENG",
    SiteIdentifier: "digitalpos",
    CustomerType: "consumer",
    PageFunction: "Error Response from the Offer Service",
    PageName: "Global Error Page",
    SiteError: "Error Response from the Offer Service",
  };

  window._syf_._mppOffer_._SFDDL.click = {
    action: "syfClickEvent",
    className: "syfClickEvent",
    "data-object": "button",
    "data-reason": "Close",
    "data-type": "body",
  };

  window._syf_._mppOffer_._SFDDL.formAction = {
    appType: "offers_mpp",
    product: "MPP",
    action: "Global Error page",
  };
  console.log(window._syf_._mppOffer_._SFDDL);

  var event = document.createEvent("Event");
  event = new CustomEvent("syfClickEvent");
  event.initEvent("syfClickEvent");
  dispatchEvent(event);
}
